// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__7BtE1","brand":"Header_brand__4DZG3","nav":"Header_nav__ZYcwj","toggler":"Header_toggler__13svj"};